/**
 * 合规内容统一配置
 *
 * Svelte 页面统一 import 本文件；DSL HTML 通过 vite `{{ CASH_LOAN_* }}` 占位符注入同一套常量。
 *
 * @see docs/prd.md CAT / 地址清单
 */

/** 信用卡最高额度（原 60000，R1 更新为 58800） */
export const MAX_CREDIT_CARD_AMOUNT = 58800;

/** 现金贷最高额度；所有页面展示、计算边界与 SEO 共用 */
export const MAX_CASH_LOAN_AMOUNT = 46800;

/** 现金贷最高额度千分位展示值 */
export const MAX_CASH_LOAN_AMOUNT_DISPLAY =
    MAX_CASH_LOAN_AMOUNT.toLocaleString('en-US');

/** 信用卡固定年利率；页面合规文案与 SEO JSON-LD 共用 */
export const CREDIT_CARD_INTEREST_RATE = 86.83;

/** 现金贷普通年利率区间；页面合规文案与 SEO JSON-LD 共用 */
export const CASH_LOAN_INTEREST_RATE_RANGE = {
    minValue: 48,
    maxValue: 300
} as const;

/** 信用卡法律主体及结构化地址 */
export const CREDIT_CARD_PROVIDER = {
    name: 'Regigold, S.A. de C.V.',
    address: {
        streetAddress:
            'Avenida Paseo de la Reforma no. 509, Piso 23 y 24, Colonia Cuauhtémoc',
        postalCode: '06500',
        addressLocality: 'Ciudad de México',
        addressRegion: 'Ciudad de México',
        addressCountry: 'MX'
    }
} as const;

/** 现金贷法律主体及结构化地址 */
export const CASH_LOAN_PROVIDER = {
    name: 'DiDi Pay, S.A. de C.V.',
    address: {
        streetAddress:
            'Avenida Paseo de la Reforma no. 509, Piso 23 y 24, Colonia Cuauhtémoc',
        postalCode: '06500',
        addressLocality: 'Ciudad de México',
        addressRegion: 'Ciudad de México',
        addressCountry: 'MX'
    }
} as const;

/** 信用卡主体地址（Regigold，S.A. de C.V.，Piso 23 y 24） */
export const CREDIT_CARD_ADDRESS = `${CREDIT_CARD_PROVIDER.name}, ${CREDIT_CARD_PROVIDER.address.streetAddress}, C.P. ${CREDIT_CARD_PROVIDER.address.postalCode}, ${CREDIT_CARD_PROVIDER.address.addressLocality}, México.`;

/** 现金贷主体地址（DiDi Pay，S.A. de C.V.，Piso 23 y 24） */
export const CASH_LOAN_ADDRESS = `${CASH_LOAN_PROVIDER.name}, ${CASH_LOAN_PROVIDER.address.streetAddress}, C.P. ${CASH_LOAN_PROVIDER.address.postalCode}, ${CASH_LOAN_PROVIDER.address.addressLocality}, México.`;

/** 现金贷 CAT */
export const CASH_LOAN_CAT = {
    /** 未提及营销活动，末尾 Consulta */
    LOAN_COMMON: `CAT promedio informativo 312.9% sin IVA. Fecha de cálculo 30 de abril del 2026. Tasa de interés ordinaria anual del ${CASH_LOAN_INTEREST_RATE_RANGE.minValue}% al ${CASH_LOAN_INTEREST_RATE_RANGE.maxValue}%. Consulta Términos y Condiciones.`,
    /** 提及 1K 免息等营销活动，末尾 *Aplican */
    LOAN_1K: `CAT promedio informativo 312.9% sin IVA. Fecha de cálculo 30 de abril del 2026. Tasa de interés ordinaria anual del ${CASH_LOAN_INTEREST_RATE_RANGE.minValue}% al ${CASH_LOAN_INTEREST_RATE_RANGE.maxValue}%. *Aplican Términos y Condiciones.`
} as const;

/** 信用卡 CAT */
export const CREDIT_CARD_CAT = {
    /** 提及 3MSI 券 / Cashback，末尾 *Aplican */
    CARD_MSI: `${CREDIT_CARD_PROVIDER.name}, CAT promedio informativo: 133.9% sin IVA. Fecha de cálculo 31 de agosto del 2026. Tasa de interés promedio ponderada anual fija del ${CREDIT_CARD_INTEREST_RATE}%, sin IVA. *Aplican Términos y Condiciones.`,
    /** 未提及营销活动 / Cashback，末尾 Consulta */
    CARD_COMMON: `${CREDIT_CARD_PROVIDER.name}, CAT promedio informativo: 133.9% sin IVA. Fecha de cálculo 31 de agosto del 2026. Tasa de interés promedio ponderada anual fija del ${CREDIT_CARD_INTEREST_RATE}%, sin IVA. Consulta Términos y Condiciones.`
} as const;
